import axios from 'axios';
import { store } from '../util/reducer';

const axiosInstance = axios.create({
    timeout: 15000,
})

axiosInstance.interceptors.request.use(
    config => {
        // Add any custom headers or configurations here
        config.withCredentials = true; // Ensure cookies are sent with requests
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if(error.response){
            if(error.response.status === 401 || error.response.status === 403){
                // Handle unauthorized or forbidden error
                if (error.response.data && error.response.data.error === 'UNAUTHORIZED') {
                    window.location.href = '/login';
                }
                return Promise.reject(error);
            }
            if(error.response.status >= 500){
                // Handle timeout error
                store.dispatch({ type: 'SET_RESERVATION_UNABLE' });
            }
        }
        else if (error.code === 'ECONNABORTED') {
            // Handle timeout error
            store.dispatch({ type: 'SET_RESERVATION_UNABLE' });
        } else {
            // Something happened in setting up the request
            store.dispatch({ type: 'SET_RESERVATION_UNABLE' });
        }
        return Promise.reject(error);
    }
)

export default axiosInstance;
